export default "__VITE_ASSET__BD7$s_re__";